var _rect, _rect2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlignColumn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 3.64,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.454545,
    y: 0.454545,
    width: 39.0909,
    height: 39.0909,
    rx: 3.18182,
    stroke: "#616161",
    strokeWidth: 0.909091
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10403_421)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8174 13.6365C11.8174 13.1543 12.0089 12.6919 12.3499 12.3509C12.6909 12.0099 13.1534 11.8184 13.6356 11.8184H26.3628C26.845 11.8184 27.3075 12.0099 27.6485 12.3509C27.9895 12.6919 28.181 13.1543 28.181 13.6365V26.3638C28.181 26.846 27.9895 27.3085 27.6485 27.6495C27.3075 27.9904 26.845 28.182 26.3628 28.182H13.6356C13.1534 28.182 12.6909 27.9904 12.3499 27.6495C12.0089 27.3085 11.8174 26.846 11.8174 26.3638V13.6365ZM26.3628 13.6365H13.6356V16.3638H26.3628V13.6365ZM13.6356 21.8184V18.182H26.3628V21.8184H13.6356ZM13.6356 23.6365V26.3638H26.3628V23.6365H13.6356Z",
    fill: "#616161"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10403_421"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.8182,
    height: 21.8182,
    fill: "white",
    transform: "translate(9.08984 9.09082)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignColumn);
export default __webpack_public_path__ + "static/media/alignColumn.ee2846944f2f303493923ef690020903.svg";
export { ForwardRef as ReactComponent };